<script>
import { BNavItemDropdown } from "bootstrap-vue";

export default {
  extends: BNavItemDropdown
};
</script>